export function emptyGoal(overrides = {}) {
  return {
    id: Date.now(),
    tags: [],
    customGoal: "",
    description: "",
    target: "",
    targetDate: "",
    importance: 7,
    isPrimary: false,
    ...overrides,
  };
}

export function uniqueGoalAreas(values = []) {
  const seen = new Set();
  return values.reduce((areas, value) => {
    const area = typeof value === "string" ? value.trim() : "";
    const key = area.toLowerCase();
    if (!area || seen.has(key)) return areas;
    seen.add(key);
    return [...areas, area];
  }, []);
}

export function normalizeGoals(profile) {
  if (Array.isArray(profile.goals) && profile.goals.length > 0) {
    const goals = profile.goals.map((goal, index) => ({
      ...emptyGoal({ id: goal.id ?? `${Date.now()}-${index}` }),
      ...goal,
      tags: goal.tags || [],
      customGoal: goal.customGoal ?? "",
      description: goal.description ?? "",
      target: goal.target ?? "",
      targetDate: goal.targetDate ?? "",
      importance: goal.importance ?? 7,
      isPrimary: Boolean(goal.isPrimary),
    }));
    return goals.some((goal) => goal.isPrimary)
      ? goals
      : goals.map((goal, index) => ({ ...goal, isPrimary: index === 0 }));
  }

  return [
    emptyGoal({
      tags: profile.goalTags || [],
      customGoal: profile.customGoal || "",
      description: profile.goalDescription || "",
      target: profile.target || "",
      targetDate: profile.targetDate || "",
      importance: profile.importance || 7,
      isPrimary: true,
    }),
  ];
}

export function migrateLegacyGoalAreas(profile) {
  const goals = normalizeGoals(profile);
  const goalTags = uniqueGoalAreas([
    ...(profile.goalTags || []),
    ...goals.flatMap((goal) => goal.tags || []),
    profile.customGoal,
    ...goals.map((goal) => goal.customGoal),
  ]);
  return {
    ...profile,
    goalTags,
    customGoal: "",
    goals: goals.map((goal) => ({ ...goal, tags: goalTags, customGoal: "" })),
  };
}

export function syncLegacyGoalFields(payload) {
  const goalTags = uniqueGoalAreas(payload.goalTags || []);
  const goals = normalizeGoals(payload).map((goal) => ({
    ...goal,
    tags: goalTags,
    customGoal: "",
  }));
  const primary = goals.find((goal) => goal.isPrimary) ||
    goals[0] ||
    emptyGoal({ isPrimary: true });
  return {
    ...payload,
    goals,
    goalTags,
    customGoal: "",
    goalDescription: primary.description || "",
    level: null,
    target: primary.target || "",
    targetDate: primary.targetDate || null,
    importance: primary.importance || 7,
    isPrimary: true,
  };
}
